import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { IsResourceBillableCellRenderer } from "../column-def-cell-renderers/IsResourceBillableCellRenderer";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { convertByteToSize } from "@/components/utils/helpers/convertByteToSize";
import { FilteredRdsSnapshotResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const rdsSnapshotColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Snapshot Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("rds_snapshot"),

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Creation Time"),

  { field: "resource.storage_type", headerName: "Storage Type" },

  {
    field: "resource.storage",
    headerName: "DB Storage Size",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredRdsSnapshotResourceItem>) => {
      if (!data) {
        return null;
      }

      const storage = data?.resource?.storage;

      return convertByteToSize(storage);
    },
  },

  {
    field: "resource.is_public",
    headerName: "Is Public",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredRdsSnapshotResourceItem>) => {
      return (
        <Typography variant="body2">
          {data?.resource?.is_public ? "Yes" : "No"}
        </Typography>
      );
    },
  },
  { field: "resource.type", headerName: "Backup Type" },
  { field: "resource.engine", headerName: "DB Engine" },
  { field: "resource.db_type", headerName: "DB Type" },

  {
    field: "resource.is_encrypted",
    headerName: "Encrypted",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredRdsSnapshotResourceItem>) => {
      return String(!!data?.resource?.is_encrypted);
    },
  },

  {
    field: "resource.billable",
    headerName: "Billable",
    cellRenderer: IsResourceBillableCellRenderer,
  },

  { field: "resource.zone", headerName: "Region" },

  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
